import React from 'react';

export default function Pagination({ 
  currentPage, 
  totalPages, 
  onPageChange,
  totalItems,
  itemsPerPage 
}) {
  if (totalPages <= 1) return null;

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px 20px',
      background: 'var(--bg-tertiary)',
      borderRadius: '12px',
      border: '1px solid rgba(0, 0, 0, 0.08)'
    }}>
      {/* Info */}
      <div style={{
        fontSize: '13px',
        color: 'var(--text-secondary)'
      }}>
        Showing {startItem}-{endItem} of {totalItems} jobs
      </div>

      {/* Page Controls */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        {/* Previous Button */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            padding: '8px 12px',
            background: currentPage === 1 ? 'var(--bg-secondary)' : 'var(--bg-tertiary)',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: '600',
            color: currentPage === 1 ? 'var(--text-tertiary)' : 'var(--text-secondary)',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
          }}
        >
          ← Previous
        </button>

        {/* Page Numbers */}
        <div style={{
          display: 'flex',
          gap: '4px'
        }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => {
            // Show first, last, current, and adjacent pages
            if (
              page === 1 ||
              page === totalPages ||
              (page >= currentPage - 1 && page <= currentPage + 1)
            ) {
              return (
                <button
                  key={page}
                  onClick={() => onPageChange(page)}
                  style={{
                    padding: '8px 12px',
                    background: page === currentPage ? 'var(--brand-brown)' : 'var(--bg-tertiary)',
                    border: '1px solid var(--input-border)',
                    borderRadius: '8px',
                    fontSize: '13px',
                    fontWeight: '600',
                    color: page === currentPage ? 'white' : 'var(--text-secondary)',
                    cursor: 'pointer',
                    minWidth: '40px'
                  }}
                >
                  {page}
                </button>
              );
            } else if (
              page === currentPage - 2 ||
              page === currentPage + 2
            ) {
              return <span key={page} style={{ padding: '8px 4px', color: 'var(--text-tertiary)' }}>...</span>;
            }
            return null;
          })}
        </div>

        {/* Next Button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            padding: '8px 12px',
            background: currentPage === totalPages ? 'var(--bg-secondary)' : 'var(--bg-tertiary)',
            border: '1px solid var(--input-border)',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: '600',
            color: currentPage === totalPages ? 'var(--text-tertiary)' : 'var(--text-secondary)',
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
          }}
        >
          Next →
        </button>
      </div>
    </div>
  );
}